import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Carregamento from "./components/Carregamento/Carregamento";
import ComponentePadrao from "./components/ComponentePadrao/ComponentePadrao";
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import CadastroChaves from "./pages/CadastroChaves";
import CadastroCliente from "./pages/CadastroCliente";
import CadastroEmpresa from "./pages/CadastroEmpresa";
import CadastroUsuario from "./pages/CadastroUsuario";
import Home from "./pages/Home";
import ListagemBanco from "./pages/ListagemBanco";
import ListagemChaves from "./pages/ListagemChaves";
import ListagemCliente from "./pages/ListagemCliente";
import ListagemEmpresa from "./pages/ListagemEmpresa";
import ListagemEquipamento from "./pages/ListagemListaEquipamentos";
import ListagemUsuario from "./pages/ListagemUsuario";
import Login from './pages/Login';
import LogsAcesso from "./pages/LogsAcesso";
import PaginaNaoEncontrada from "./pages/PaginaNaoEncontrada";
import ReexecucaoMigration from "./pages/ReexecucaoMigration";
import RelatorioAuditoria from "./pages/RelatorioAuditoria";
import { APP_ROUTES } from './services/app_routes';
import { limparCache, recuperarCache } from "./services/cacheHandler";
import { isDev, PERMISSOES } from "./utils/PermissaoUtils";


const ProtectedRoute = ({ element, role, somenteDev }) => {
  const { user, carregando } = useAuth();

  if (carregando) return <Carregamento />;

  if (!user) {
    limparCache();
    return <Navigate to="/login" replace />;
  }

  const permissoesUsuarioKeys = Object.keys(recuperarCache('permissoes'));
  if (role && !permissoesUsuarioKeys.includes(role)) {
    return <Navigate to="/" replace />;
  }

  if (somenteDev && !isDev()) {
    return <Navigate to="/" replace />;
  }

  return element;
}

function App() {
  return (
    <div className="App">
      <Router>
        <ToastContainer />
        <ThemeProvider>
          <AuthProvider>
            <Routes>
              <Route path={APP_ROUTES.LOGIN} element={<Login />} />
              <Route
                path={APP_ROUTES.HOME}
                element={
                  <ProtectedRoute
                    element={
                      <ComponentePadrao>
                        <Home />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Cliente */}
              <Route
                path={APP_ROUTES.CLIENTE_CADASTRO}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.CLIENTE_CADASTRAR}
                    element={
                      <ComponentePadrao>
                        <CadastroCliente />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.CLIENTE_VISUALIZAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.CLIENTE_LISTAR}
                    element={
                      <ComponentePadrao>
                        <ListagemCliente />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.CLIENTE_GERAL_EDITAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.CLIENTE_EDITAR}
                    element={
                      <ComponentePadrao>
                        <CadastroCliente isEdit={true} />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Empresa */}
              <Route
                path={APP_ROUTES.EMPRESA_CADASTRO}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.EMPRESA_CADASTRAR}
                    element={
                      <ComponentePadrao>
                        <CadastroEmpresa />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.EMPRESA_VISUALIZAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.EMPRESA_LISTAR}
                    element={
                      <ComponentePadrao>
                        <ListagemEmpresa />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.EMPRESA_EDITAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.EMPRESA_EDITAR}
                    element={
                      <ComponentePadrao>
                        <CadastroEmpresa isEdit={true} />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Usuário */}
              <Route
                path={APP_ROUTES.USUARIO_VISUALIZAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.USUARIO_LISTAR}
                    element={
                      <ComponentePadrao>
                        <ListagemUsuario />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.USUARIO_CADASTRO}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.USUARIO_CADASTRAR}
                    element={
                      <ComponentePadrao>
                        <CadastroUsuario />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.USUARIO_EDITAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.USUARIO_EDITAR}
                    element={
                      <ComponentePadrao>
                        <CadastroUsuario isEdit={true} />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Banco */}
              <Route
                path={APP_ROUTES.BANCO_VISUALIZAR}
                element={
                  <ProtectedRoute
                    somenteDev
                    element={
                      <ComponentePadrao>
                        <ListagemBanco />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Equipamento */}
              <Route
                path={APP_ROUTES.EQUIPAMENTO_VISUALIZAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.EQUIPAMENTO_LISTAR}
                    element={
                      <ComponentePadrao>
                        <ListagemEquipamento />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Relatórios */}
              <Route
                path={APP_ROUTES.RELATORIO_AUDITORIA}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.USUARIO_LISTAR}
                    element={
                      <ComponentePadrao>
                        <RelatorioAuditoria />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Desenvolvimento */}
              <Route
                path={APP_ROUTES.DESENVOLVIMENTO_CHAVES}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.APIKEY_LISTAR}
                    element={
                      <ComponentePadrao>
                        <ListagemChaves />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.DESENVOLVIMENTO_CHAVES_CADASTRO}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.APIKEY_CADASTRAR}
                    element={
                      <ComponentePadrao>
                        <CadastroChaves />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.DESENVOLVIMENTO_CHAVES_EDITAR}
                element={
                  <ProtectedRoute
                    role={PERMISSOES.APIKEY_EDITAR}
                    element={
                      <ComponentePadrao>
                        <CadastroChaves isEdit={true} />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.DESENVOLVIMENTO_MIGRATION}
                element={
                  <ProtectedRoute
                    element={
                      <ComponentePadrao>
                        <ReexecucaoMigration />
                      </ComponentePadrao>
                    }
                  />
                }
              />
              <Route
                path={APP_ROUTES.DESENVOLVIMENTO_LOGS}
                element={
                  <ProtectedRoute
                    element={
                      <ComponentePadrao>
                        <LogsAcesso />
                      </ComponentePadrao>
                    }
                  />
                }
              />

              {/* Página 404 - Deve ser a última rota */}
              <Route
                path="*"
                element={
                  <ComponentePadrao>
                    <PaginaNaoEncontrada />
                  </ComponentePadrao>
                }
              />
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </Router>
    </div>
  );
}

export default App;
